import { SVGProps } from '@components/Icon/types';

export const Results = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.95073C16 1.6892 14.9199 0.673161 13.5804 0.673161H11.9329C11.6566 0.269361 11.1754 0 10.6322 0H5.3679C4.8227 0 4.33988 0.27139 4.06407 0.677721L2.33236 0.674602C1.03343 0.717605 0 1.71673 0 2.95073V17.7224C0 18.984 1.08008 20 2.41955 20H13.5805C14.9199 20 16 18.984 16 17.7224V2.95073ZM10.8669 2.74461C10.9969 2.65859 10.9969 2.55308 10.9969 2.55308V2.06821V1.45963C10.9969 1.45963 10.9969 1.35108 10.9177 1.28728C10.7776 1.17432 10.6322 1.19845 10.6322 1.19845H5.3679C5.3679 1.19845 5.26326 1.18208 5.13324 1.2681C5.00322 1.35413 5.00321 1.45963 5.00321 1.45963V2.06821V2.55308C5.00321 2.55308 5.00321 2.66163 5.08236 2.72543C5.2225 2.83839 5.36789 2.81426 5.36789 2.81426H10.6322C10.6322 2.81426 10.7368 2.83064 10.8669 2.74461ZM3.82084 1.9447L2.41966 1.94569C1.82341 1.94569 1.35132 2.39041 1.35132 2.95073L1.35132 17.7224C1.35132 18.2827 1.8233 18.7275 2.41955 18.7275H13.5805C14.1767 18.7275 14.6487 18.2827 14.6487 17.7224L14.6487 2.95073C14.6487 2.39041 14.1767 1.94569 13.5804 1.94569H12.1793V2.55308C12.1793 3.35429 11.4814 4.01271 10.6322 4.01271H5.36789C4.51869 4.01271 3.82084 3.35429 3.82084 2.55308V1.9447Z"
        fill={fill}
      />
      <path
        d="M10.6808 8.30518C10.9544 8.0321 11.397 8.03256 11.6701 8.30615C11.9431 8.57976 11.9427 9.0223 11.6691 9.29541L7.41714 13.5405C7.14382 13.8134 6.70111 13.8134 6.42789 13.5405L4.30484 11.4175C4.03178 11.1442 4.03182 10.7015 4.30484 10.4282C4.57821 10.1549 5.02171 10.1549 5.29507 10.4282L6.92203 12.0552L10.6808 8.30518Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'clipboard-result';
